import {
  IMealCountKey,
  ChangeTracking,
  ReceivedMeals,
  ServingLine,
  ProgramType
} from '@/models';

export interface IMealCountDto extends IMealCountKey {
  receivedMeals: ReceivedMeals;
  servingLines: ServingLine[];
}

// TODO: make MealCounts and MealCountStatus implement IMealCountKey
//  then we'll be able to consolidate all kinds of list lookups to IMealCountKey comparisons.
//  Need to consolidate serviceDate/mealServiceDate in all layers for this to work.
export class MealCountDto extends ChangeTracking implements IMealCountDto {
  constructor(
    public trackingId: string = '',
    public siteId: number = 0,
    public programId: string = ProgramType.SFSP,
    public mealTypeId: string = '',
    public mealServiceDate: string = '',
    public versionDateTimeUtc: string = '',
    public isNonCongregate: boolean = false,
    public providedDays: number = 0,
    public receivedMeals: ReceivedMeals = new ReceivedMeals(),
    public servingLines: ServingLine[] = []
  ) {
    super();
  }
}
